import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export function NotificationsPopover() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Notifications"
          className="h-9 w-9 rounded-full relative"
        >
          <Bell className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 rounded-2xl overflow-hidden">
        <div className="px-4 py-3 border-b border-border">
          <p className="text-sm font-semibold text-foreground">Notifications</p>
          <p className="text-xs text-muted-foreground mt-0.5">Recent platform activity</p>
        </div>
        <div className="px-4 py-8 text-center">
          <Bell className="h-6 w-6 text-muted-foreground/60 mx-auto mb-2" />
          <p className="text-sm text-muted-foreground">You're all caught up.</p>
          <p className="text-xs text-muted-foreground/80 mt-1">
            New activity will appear here.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
}
